// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"SectionFAQ_sectionContainer__1BWFs","sectionHeader":"SectionFAQ_sectionHeader__3Kytv"};